import { render, staticRenderFns } from "./StartedOffboarding.vue?vue&type=template&id=7c6408aa"
import script from "./StartedOffboarding.vue?vue&type=script&lang=js"
export * from "./StartedOffboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports